import React from 'react';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { Stack, IStackStyles } from '@fluentui/react/lib/Stack';
import dottedWelcome from '../../assets/dotted-welcome.svg';
/**
 * @param text : The text to be displayed on the circular Screen
 */
type WelcomeButtonProps = {
  text?: string;
};

const textStyle = mergeStyles({
  marginBottom: 0,
  fontSize: 20,
});

const containerStyle: IStackStyles = {
  root: {
    padding: '85px 43px 56px 45px',
    height: '302px',
    width: '302px',
    border: 'none',
    borderRadius: '50%',
    backgroundColor: 'white',
    boxShadow: '5px 7px 0px rgba(255, 180, 35, 1)', // This is a custom shadow
    color: '#FFFFFF',
    textAlign: 'center',
  },
};

const imageStyle = mergeStyles({
  display: 'block',
  margin: 'auto',
  padding: '15px',
});

/**
 * This component is used to a big circular button
 * @param text : The text to be displayed on the circular button
 *
 */
const WelcomeButton = ({ ...props }: WelcomeButtonProps): JSX.Element => {
  return (
    <Stack styles={containerStyle}>
      <p className={textStyle}>{props.text}</p>
      <img src={dottedWelcome} className={imageStyle} />
    </Stack>
  );
};

export { WelcomeButton };
